<template>
  <a target="_blank" :href="commitLink">
    <div :title="revisionTitle" class="revision" v-html="revisionText"></div>
  </a>
</template>

<script>
import { format } from 'date-fns';
import { mapActions, mapState } from 'vuex';
import differenceInDays from 'date-fns/difference_in_days';

export default {
  computed: {
    ...mapState('settings', ['revision']),
    revisionTitle() {
      if (!this.revision) {
        return '';
      }
      const { hash, createdAt, author } = this.revision.lastCommit;
      return `Revision Info:\n\n${this.revision.branch}\n${author}\n${format(createdAt, 'DD.MM.YY HH:mm:ss')}\n${hash}`;
    },
    revisionText() {
      if (!this.revision) {
        return '';
      }
      if (differenceInDays(new Date(), this.revision.lastCommit.createdAt)) {
        return `${format(this.revision.lastCommit.createdAt, 'DD.MM')}`;
      }
      return `${format(this.revision.lastCommit.createdAt, 'HH:mm')}`;
    },
    commitLink() {
      if (!this.revision) {
        return '';
      }
      return `https://gitlab.com/theflowglobal/cryptoalerts/commit/${this.revision.lastCommit.hash}`;
    },
  },
  methods: {
    ...mapActions('settings', ['getCurrentRevision']),
  },
  created() {
    if (!this.revision) {
      this.getCurrentRevision();
    }
  },
};
</script>

<style lang="scss" scoped>
.revision {
  color: $white-color2;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SidePanel/TheRevision.vue